// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EaW8","type":"styles_type__2Vsm_","choices":"styles_choices__22yej"};